module.exports = __webpack_public_path__ + "static/media/sc2.62e27132.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/sc2.png
// module id = 107
// module chunks = 0